var map = {
	"./afis.jpeg": "76c0",
	"./gallery/zsk (1).jpg": "54d5",
	"./gallery/zsk (10).jpg": "ada6",
	"./gallery/zsk (11).jpg": "1a84",
	"./gallery/zsk (12).jpg": "b502",
	"./gallery/zsk (2).jpg": "d228",
	"./gallery/zsk (3).jpg": "3d7c",
	"./gallery/zsk (4).jpg": "150d",
	"./gallery/zsk (5).jpg": "523e",
	"./gallery/zsk (6).jpg": "945f",
	"./gallery/zsk (7).jpg": "82d3",
	"./gallery/zsk (8).jpg": "6ae5",
	"./gallery/zsk (9).jpg": "0e62",
	"./team.png": "21e1",
	"./team/avatar.jpg": "1bb2",
	"./team/cigdem.jpg": "82a2",
	"./team/enes.jpg": "f262",
	"./team/izzet.png": "5669",
	"./team/kaan.jpg": "3c22",
	"./team/mehtap.jpg": "655f",
	"./team/mustafa.jpg": "7eab",
	"./team/orkhan.jpg": "95c5",
	"./team/seda.png": "a834",
	"./turkey.svg": "b45f",
	"./uk.svg": "8da5",
	"./zingal-logo.png": "07f5",
	"./zingal-webm.webm": "bd01",
	"./zingal.mp4": "96ec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";